import { BuildingIcon, FileTextIcon, TagIcon, User } from '@commander/ui';
import type { ComponentType } from 'react';
import type { SearchEntity } from '../search.types';

type IconComponent = ComponentType<{ className?: string }>;

const icons: Record<SearchEntity, IconComponent> = {
  company: BuildingIcon,
  contact: User,
  deal: TagIcon,
  quote: FileTextIcon,
};

export function SearchEntityIcon({
  entity,
  className,
}: {
  entity: SearchEntity;
  className?: string;
}) {
  const Icon = icons[entity];
  return <Icon className={className} />;
}
